import { Routes, Route } from 'react-router-dom';
import loadable from '@loadable/component';

const DataTable = loadable(() => import('./dataTableComponent'), {
	fallback: null,
});

export default function IndexLevelTableRoute() {
	return (
		<Routes>
			<Route path="/" element={<DataTable />} />
			<Route path="/:company" element={<DataTable />} />
		</Routes>
	);
}
